import { AxiosResponse } from 'axios';
import apiCallWrapper from '../../apiwrapper/apiCallWrapper';
import { APIResponse } from '../Helper/type';
import IRepoOwner from './RepoOwner.interface';

const backEndServerUrl = String(process.env.REACT_APP_BACK_END_SERVER_URL ?? '');

export default class RepoOwnerService {
  public subPath: string = '/repoOwner';

  public async getAllRepoOwners(): Promise<IRepoOwner[]> {
    try {
      const axiosInstance = apiCallWrapper(this.subPath, 'GET');
      const url = `${backEndServerUrl}${this.subPath}`;
      const response: AxiosResponse = await axiosInstance.get(url);
      return response.data ?? [];
    } catch (error: any) {
      console.error('Error fetching repo owners:', error);
      return [];
    }
  }

  public async getRepoOwnerByName(name: string): Promise<IRepoOwner | null> {
    try {
      const axiosInstance = apiCallWrapper(this.subPath, 'GET');
      const url = `${backEndServerUrl}${this.subPath}/${name}`;
      const response: AxiosResponse = await axiosInstance.get(url);
      return response.data ?? null;
    } catch (error: any) {
      console.error('Error fetching repo owner:', error);
      return null;
    }
  }

  public async createRepoOwner(repoOwner: IRepoOwner): Promise<APIResponse> {
    try {
      const axiosInstance = apiCallWrapper(this.subPath, 'POST');
      const url = `${backEndServerUrl}${this.subPath}`;
      const response: AxiosResponse = await axiosInstance.post(url, repoOwner);
      return { statusCode: response.status, body: response.data };
    } catch (error: any) {
      return { statusCode: error?.response?.status ?? 500, body: error?.response?.data ?? 'Failed to create owner' };
    }
  }

  public async updateRepoOwner(repoOwner: IRepoOwner, originalName?: string): Promise<APIResponse> {
    try {
      const axiosInstance = apiCallWrapper(this.subPath, 'PUT');
      const url = `${backEndServerUrl}${this.subPath}/${originalName ?? repoOwner.repoOwnerName}`;
      const response: AxiosResponse = await axiosInstance.put(url, repoOwner);
      return { statusCode: response.status, body: response.data };
    } catch (error: any) {
      return { statusCode: error?.response?.status ?? 500, body: error?.response?.data ?? 'Failed to update owner' };
    }
  }

  public async deleteRepoOwner(repoOwner: IRepoOwner): Promise<APIResponse> {
    try {
      const axiosInstance = apiCallWrapper(this.subPath, 'DELETE');
      const url = `${backEndServerUrl}${this.subPath}/${repoOwner.repoOwnerName}`;
      const response: AxiosResponse = await axiosInstance.delete(url, { data: repoOwner });
      return { statusCode: response.status, body: response.data };
    } catch (error: any) {
      return { statusCode: error?.response?.status ?? 500, body: error?.response?.data ?? 'Failed to delete owner' };
    }
  }
}
